// @flow
import React, { type Node } from 'react';
import { Input, Col, Panel, Row } from 'angieslist-react-components';
import type { BrowserReducerState } from '../../../types';
import CopyTextButtonComponent from '../../components/CopyTextButton';
import './RequestReviewsCta.scss';

type Props = {
  serviceProviderId: string,
  browser: BrowserReducerState,
  requestedReviewPURL: string,
};

const RequestReviewsCtaComponent =
({ serviceProviderId, browser, requestedReviewPURL }: Props): Node => {
  const targetToCopyId = 'target-to-copy--PURL';
  return (
    <Panel>
      <Panel.Body>
        <Row
          style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
        }}
          className={browser.lessThan.md ? 'text-center' : ''}
        >
          <Col xs={12} md={6}>
            <h4 style={{ marginTop: 0 }}>Get More Reviews</h4>
            <p>
              Copy your Personalized Review Link and share it with any
              of your customers when you request a review.
            </p>
          </Col>
          <Col xs={12} md={3} mdOffset={2}>
            <div style={{ margin: '10px' }}>
              <CopyTextButtonComponent
                id="request-review-button"
                targetId={targetToCopyId}
                bsStyle="primary-office"
              />
              <Input
                id={targetToCopyId}
                type="text"
                defaultValue={requestedReviewPURL}
                readOnly
                style={{ marginTop: '10px', marginBottom: '0px' }}
              />
            </div>
          </Col>
        </Row>
      </Panel.Body>
    </Panel>
  );
};

export default RequestReviewsCtaComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/RequestReviewsCta.js